"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.getToken = void 0;
var axios_1 = __importDefault(require("axios"));
var camelize_1 = __importDefault(require("camelize"));
var query_string_1 = __importDefault(require("query-string"));
var constants_1 = require("./constants");
exports.getToken = function (settings) { return __awaiter(void 0, void 0, void 0, function () {
    var baseUrl, realmName, url, credentials, payload, config, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                baseUrl = settings.baseUrl || constants_1.defaultBaseUrl;
                realmName = settings.realmName || constants_1.defaultRealm;
                url = baseUrl + "/realms/" + realmName + "/protocol/openid-connect/token";
                credentials = settings.credentials || {};
                payload = query_string_1["default"].stringify(__assign(__assign({ username: credentials.username, password: credentials.password, grant_type: credentials.grantType, client_id: credentials.clientId, totp: credentials.totp }, (credentials.offlineToken ? { scope: 'offline_access' } : {})), (credentials.refreshToken ? {
                    refresh_token: credentials.refreshToken,
                    client_secret: credentials.clientSecret
                } : {})));
                config = __assign({}, settings.requestConfig);
                if (credentials.clientSecret) {
                    config.auth = {
                        username: credentials.clientId,
                        password: credentials.clientSecret
                    };
                }
                return [4, axios_1["default"].post(url, payload, config)];
            case 1:
                data = (_a.sent()).data;
                return [2, camelize_1["default"](data)];
        }
    });
}); };
//# sourceMappingURL=auth.js.map